import React,{Component} from 'react';
import {
  Nav,
  NavItem,
  NavLink,
  Container,
  Row,
  Col
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';
import Route from 'react-router-dom/Route';
import Switch from 'react-router-dom/Switch';

import RetailerInfo from '../../RetailerInfo';
import RetailerUserList from '../../RetailerUserList';
import RetailerUserView from '../../RetailerUserView';

class RetailerView extends Component {
  componentDidMount(){
    if(this.props.needsLoading){
      this.props.loadRetailer(this.props.retailerId);
    }
  }


  render(){

    const {
      match,
      retailerId,
      name,
      needsLoading
    } = this.props;

    return (
      <Container>
        <Row>
          <Col xs='12'>
            <br />
            <h6>Publisher</h6>
            <h3>{name || 'Loading...'}</h3>
            <br />
          </Col>
        </Row>
        <Row>
          <Col xs='12'>
            <Nav tabs className='UnderLineTabs'>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/edit`}
                  activeClassName='active'
                >
                  Info
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/users`}
                  activeClassName='active'
                >
                  App Users
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
        </Row>
        <br />
        {!needsLoading && (
          <Switch>
            <Route
              path={`${match.url}/edit`}
              render={() => (<RetailerInfo retailerId={retailerId} />)}
            />
            <Route
              path={`${match.url}/users/:appUserId`}
              render={() => (<RetailerUserView retailerId={retailerId} />)}
            />
            <Route
              path={`${match.url}/users`}
              render={() => (<RetailerUserList retailerId={retailerId} />)}
            />
          </Switch>
        )}
      </Container>
    )
  }
}

export default RetailerView;



// WEBPACK FOOTER //
// ./src/routes/RetailerView/components/RetailerView.js